import { paramsObject } from "helpers/system";
import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/parcel";
import Form from "./form";
import List from "./list";

export default function ParcelStatuses(props) {
    useEffect(() => {
        return () => props.clearParams("admin-parcel-statuses");
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Статусы отслеживания документов"
                            nofilter
                            createBtnText="Добавить статус"
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => {
                        const { provider } = paramsObject(props.location.search);
                        return (
                            <Form
                                {...rest}
                                provider={provider}
                                transition="full"
                                title="Статус отслеживания документов"
                                back={back}
                                source={source}
                            />
                        );
                    }}
                />
                <Route
                    path={`${match.path}/new`}
                    render={() => (
                        <Form {...props} transition="full" title="Добавить статус" back={back} source={source} />
                    )}
                />
            </Switch>
        </div>
    );
}
